import { render, staticRenderFns } from "./study-report.vue?vue&type=template&id=21170c9b&scoped=true"
import script from "./study-report.vue?vue&type=script&lang=js"
export * from "./study-report.vue?vue&type=script&lang=js"
import style0 from "./study-report.vue?vue&type=style&index=0&id=21170c9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21170c9b",
  null
  
)

export default component.exports